import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BarGraph from "../../components/graphs/BarGraph";
import dataService from "../../networks/api/service/dataService";

function AssemblyGraphDetails() {
  const [assemblyList, setassemblyList] = useState([]);

  const { id } = useParams();
  const location = useLocation();
  const { constituencyName } = location.state || {};

  const navigate = useNavigate();
  const getAssemblyFromConst = async () => {
    try {
      const res = await dataService.getAssemblyFromConstituency(id);
      if (res.code === 200) {
        setassemblyList(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getAssemblyFromConst();
  }, [id]);

  const handleBarClick = (data) => {
    if (data._id) {
      navigate(`/login/panchayat-graph-details/${data._id}`, {
        state: { assemblyName: data.assemblyName },
      });
    }
  };

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#f9f9f9",
        borderRadius: "12px",
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
      }}
    >
      {" "}
      <BarGraph
        data={assemblyList}
        xKey="assemblyName"
        title={`Details for Parliament : ${constituencyName}`}
        bars={[
          {
            key: "totalPopulation",
            color: "#8884d8",
            name: "Total Population",
          },
          { key: "totalMaleVoter", color: "#82ca9d", name: "Male Voters" },
          {
            key: "totalFemaleVoter",
            color: "#ffc658",
            name: "Female Voters",
          },
        ]}
        onBarClick={handleBarClick}
      />
    </div>
  );
}

export default AssemblyGraphDetails;
